(function() {

  const overlay = document.querySelector('.r-mini-calc-overlay');

  if (!overlay) return;

  const padsInput = document.getElementById('r-mini-pads');
  const periodsInput = document.getElementById('r-mini-periods');
  const piecesInput = document.getElementById('r-mini-pieces');
  const productInput = document.getElementById('r-mini-product');

  const savingsEl = document.getElementById('r-mini-savings');
  const disposableEl = document.getElementById('r-mini-disposable');
  const revaaEl = document.getElementById('r-mini-revaa');
  const costEl = document.getElementById('r-mini-cost-incurred');
  const ctaEl = document.getElementById('r-mini-cta');

  const periodsTextEl =
    document.getElementById('r-mini-periods-text');

  const paybackPeriodsEl =
    document.getElementById('r-mini-payback-periods');

  const productNameEl =
    document.getElementById('r-mini-product-name');

  const yearlySavingEl =
    document.getElementById('r-mini-year-saving');

  const disposableBarEl =
    document.getElementById('r-mini-disposable-bar');

  const revaaBarEl =
    document.getElementById('r-mini-revaa-bar');

  const ecoPeriodsEl =
    document.getElementById('r-mini-eco-periods');

  const padsAvoidedEl =
    document.getElementById('r-mini-pads-avoided');

  const plasticSavedEl =
    document.getElementById('r-mini-plastic-saved');

  const waterSavedEl =
    document.getElementById('r-mini-water-saved');

  const productUrls = {

    trialKit:
      '/products/revaa-trial-pack',

    hipHugger:
      '/products/hiphugger-lovers',

    classicBoyshorts:
      '/products/classic-boyshort-navy',

    seamfreeHipHugger:
      '/products/seamfree-hip-hugger-black'

  };

  function formatMoney(value) {

    return '₹' +
      Number(value).toLocaleString('en-IN');

  }

  function applyProductDefaults() {

    const product =
      productInput.value;

    if (product === 'trialKit') {

      piecesInput.value = 1;

    } else {

      piecesInput.value = 3;

    }

    if (product === 'classicBoyshorts') {

      periodsInput.value = 18;

    } else {

      periodsInput.value = 12;

    }

  }

  function updateCalculator() {

    const result =
      window.RevaaCalculatorCore.calculate({

        padsPerPeriod:
          padsInput.value,

        periods:
          periodsInput.value,

        pieces:
          piecesInput.value,

        product:
          productInput.value

      });

    if (!result) return;

    /* ======================================
       BASIC VALUES
    ====================================== */

    savingsEl.textContent =
      Number(result.savings)
      .toLocaleString('en-IN');

    disposableEl.textContent =
      formatMoney(result.disposableCost);

    revaaEl.textContent =
      formatMoney(result.revaaCost);

    costEl.textContent =
      Number(result.revaaCost)
      .toLocaleString('en-IN');

if (ctaEl) {

  ctaEl.href =
    'https://revaaforyou.com/pages/revaa-sustainability-calculator';

}

    /* ======================================
       PRODUCT NAME
    ====================================== */

    const selectedText =
      productInput.options[
        productInput.selectedIndex
      ].text;

    const productName =
      selectedText
        .split('—')[0]
        .trim();

    if (productNameEl) {

      productNameEl.textContent =
        productName;

    }

    /* ======================================
       PERIODS
    ====================================== */

    if (periodsTextEl) {

      periodsTextEl.textContent =
        periodsInput.value;

    }

    if (ecoPeriodsEl) {

      ecoPeriodsEl.textContent =
        periodsInput.value;

    }

    /* ======================================
       YEARLY SAVING
    ====================================== */

    const yearlySaving =
      Math.round(
        (
          result.savings /
          Number(periodsInput.value)
        ) * 12
      );

    if (yearlySavingEl) {

      yearlySavingEl.textContent =
        formatMoney(yearlySaving) +
        ' / year';

    }

    /* ======================================
       PAYBACK PERIODS
    ====================================== */

    const disposablePerPeriod =
      Number(padsInput.value) * 12;

    const payback =
      Math.ceil(
        result.revaaCost /
        disposablePerPeriod
      );

    if (paybackPeriodsEl) {

      paybackPeriodsEl.textContent =
        payback;

    }

    /* ======================================
       BARS
    ====================================== */

    const max =
      Math.max(
        result.disposableCost,
        result.revaaCost,
        1
      );

    const disposableWidth =
      (
        result.disposableCost /
        max
      ) * 100;

    const revaaWidth =
      (
        result.revaaCost /
        max
      ) * 100;

    if (disposableBarEl) {

      disposableBarEl.style.width =
        disposableWidth + '%';

    }

    if (revaaBarEl) {

      revaaBarEl.style.width =
        revaaWidth + '%';

    }

    /* ======================================
       ECO
    ====================================== */

    const totalPads =
      Number(padsInput.value) *
      Number(periodsInput.value);

    const plastic =
      (
        (totalPads * 9) / 1000
      ).toFixed(1);

    const water =
      Math.round(
        totalPads * 1.2
      );

    if (padsAvoidedEl) {

      padsAvoidedEl.textContent =
        totalPads.toLocaleString('en-IN');

    }

    if (plasticSavedEl) {

      plasticSavedEl.textContent =
        plastic;

    }

    if (waterSavedEl) {

      waterSavedEl.textContent =
        water.toLocaleString('en-IN') +
        'L';

    }

  }

  document
    .querySelectorAll('.r-mini-plus')
    .forEach(button => {

      button.addEventListener(
        'click',
        function() {

          const target =
            this.dataset.target;

          if (target === 'pads') {

            padsInput.value =
              Number(
                padsInput.value
              ) + 1;

          }

          if (target === 'pieces') {

            piecesInput.value =
              Number(
                piecesInput.value
              ) + 1;

          }

          if (target === 'periods') {

            periodsInput.value =
              Number(
                periodsInput.value
              ) + 1;

          }

          updateCalculator();

        }
      );

    });

  document
    .querySelectorAll('.r-mini-minus')
    .forEach(button => {

      button.addEventListener(
        'click',
        function() {

          const target =
            this.dataset.target;

          if (target === 'pads') {

            padsInput.value =
              Math.max(
                20,
                Number(
                  padsInput.value
                ) - 1
              );

          }

          if (target === 'pieces') {

            piecesInput.value =
              Math.max(
                1,
                Number(
                  piecesInput.value
                ) - 1
              );

          }

          if (target === 'periods') {

            periodsInput.value =
              Math.max(
                1,
                Number(
                  periodsInput.value
                ) - 1
              );

          }

          updateCalculator();

        }
      );

    });

  productInput.addEventListener(
    'change',
    function() {

      applyProductDefaults();

      updateCalculator();

    }
  );

  [
    padsInput,
    periodsInput,
    piecesInput
  ].forEach(el => {

    if (!el) return;

    el.addEventListener(
      'change',
      updateCalculator
    );

  });

  document.addEventListener(
    'click',
    function(e) {

      const trigger =
        e.target.closest(
          '.r-mini-calc-trigger'
        );

      if (!trigger) return;

      e.preventDefault();

      const product =
        trigger.dataset.product;

      if (product) {

        productInput.value =
          product;

        applyProductDefaults();

      }

      document.body.classList.add(
        'r-mini-calc-open'
      );

      updateCalculator();

    }
  );

  document
    .querySelector('.r-mini-calc-close')
    .addEventListener(
      'click',
      function() {

        document.body.classList.remove(
          'r-mini-calc-open'
        );

      }
    );

  overlay.addEventListener(
    'click',
    function(e) {

      if (e.target === overlay) {

        document.body.classList.remove(
          'r-mini-calc-open'
        );

      }

    }
  );

  applyProductDefaults();

  updateCalculator();

})();